import { useMachine } from '@xstate/react'
import {
  getSignedSubtitles,
  GetSignedSubtitlesResults,
} from 'api/subtitles/getSignedSubtitles'
import { requestMachine } from 'machines'
import { useCallback, useRef } from 'react'

export const useGetSignedSubtitles = (): [
  (id: string) => void,
  GetSignedSubtitlesResults['results'],
  boolean,
  string
] => {
  const [urlState, urlSend] = useMachine(requestMachine)
  const videoId = useRef<string>()

  const get = useCallback(
    (id: string) => {
      videoId.current = id
      const promise = getSignedSubtitles({ id })
      urlSend('SET_PROMISE', { data: promise })
    },
    [urlSend]
  )
  const subtitles = urlState.matches('success') && urlState.context.data.results

  const errorMessage = urlState.matches('failed') ? urlState.context.error : ''

  const loading = urlState.matches('syncing')
  return [get, subtitles, loading, errorMessage]
}
